import { TemplateRef } from '@angular/core';

export interface IUIDialog {
    dialogTemplate: TemplateRef<any>;
}
